<ng-container>
  <div class="card">
    <div class="header">
      <div class="title">Warranty</div>
      <div class="subtitle">Optional coverage for {{ product?.ItemName }}</div>
    </div>

    <div class="options">
      <label class="option" *ngFor="let opt of options; let i = index">
        <input type="radio" name="warranty" [value]="opt" [checked]="selectedIndex === i" (change)="select(i)" />
        <span class="label">{{ opt.Label }}</span>
        <span class="spacer"></span>
        <!-- <span class="price">{{ opt.Price | number }} %</span> -->
        <span class="price">{{ ((opt.Price / 100) * product?.Quantity * product?.Price)
          + ((opt.TaxRate / 100) * product?.Quantity * ((opt.Price / 100) * product?.Price))
          | currency:product?.Currency:'symbol-narrow':'1.0-2'
          }}</span>
      </label>
    </div>

    <div class="footer" *ngIf="selectedIndex !== null">
      <div class="row">
        <span>Base price</span>
        <span class="value">{{ product?.LineTotal | currency:product?.Currency:'symbol-narrow':'1.0-2' }}</span>
      </div>
      <div class="row">
        <span>Warranty</span>
        <span class="value">+ {{ ((options[selectedIndex!].Price / 100) * product?.Quantity * product?.Price)
          + ((options[selectedIndex!].TaxRate / 100) * product?.Quantity * ((options[selectedIndex!].Price / 100) *
          product?.Price)) |
          currency:product?.Currency:'symbol-narrow':'1.0-2'
          }}</span>
      </div>
      <div class="row total">
        <span>Total</span>
        <span class="value">{{ (product.LineTotal) + ((options[selectedIndex!].Price / 100) * product?.Quantity *
          product?.Price) + + ((options[selectedIndex!].TaxRate / 100) * product?.Quantity *
          ((options[selectedIndex!].Price / 100) * product?.Price)) |
          currency:product?.Currency:'symbol-narrow':'1.0-2' }}</span>
      </div>
      <button class="submit" (click)="submit()">Submit</button>
    </div>
  </div>
</ng-container>
